<template>
  <div
    v-if="loading && this.value > 0"
    class="d-flex justify-center"
    style="height: 100%"
  >
    <v-progress-circular
      style="align-self: center"
      :model-value="value"
      :rotate="360"
      :size="100"
      :width="15"
      color="blue-lighten-1"
    >
      <template v-slot:default> {{ value }} % </template>
    </v-progress-circular>
  </div>
  <div v-else>
    <v-container
      height="100vh"
      align="center"
      class="align-content-center"
      v-if="$store.state.isMobile"
    >
      <v-row>
        <v-col align="center">
          <h1>Настройка электронной почты</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="ma-0 pa-0">
          <v-btn stacked variant="outlined" width="110" :disabled="loading">
            <template v-slot:prepend>
              <v-icon
                ><svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M31.96 17.3542C31.96 16.2492 31.8608 15.1867 31.6767 14.1667H17V20.2017H25.3867C25.0183 22.1425 23.9133 23.7858 22.2558 24.8908V28.815H27.3133C30.26 26.095 31.96 22.1 31.96 17.3542Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M17 32.5833C21.2075 32.5833 24.735 31.195 27.3133 28.815L22.2558 24.8908C20.8675 25.8258 19.0967 26.3925 17 26.3925C12.9483 26.3925 9.50583 23.6583 8.27333 19.975H3.08833V23.9983C5.6525 29.0842 10.9083 32.5833 17 32.5833Z"
                    fill="#34A853"
                  />
                  <path
                    d="M8.27333 19.9608C7.96166 19.0258 7.7775 18.0342 7.7775 17C7.7775 15.9658 7.96166 14.9742 8.27333 14.0392V10.0158H3.08833C2.02583 12.1125 1.41666 14.4783 1.41666 17C1.41666 19.5217 2.02583 21.8875 3.08833 23.9842L7.12583 20.8392L8.27333 19.9608Z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M17 7.62166C19.295 7.62166 21.335 8.41499 22.9642 9.94499L27.4267 5.48249C24.7208 2.96082 21.2075 1.41666 17 1.41666C10.9083 1.41666 5.6525 4.91582 3.08833 10.0158L8.27333 14.0392C9.50583 10.3558 12.9483 7.62166 17 7.62166Z"
                    fill="#EA4335"
                  />
                </svg>
              </v-icon>
            </template>
            Gmail</v-btn
          >
        </v-col>
        <v-col class="ma-0 pa-0">
          <v-btn
            stacked
            variant="outlined"
            width="110"
            :disabled="loading"
            @click="loginWithYandex"
          >
            <template v-slot:prepend>
              <v-icon
                ><svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 29.4666H34V4.53317H0V29.4666Z"
                    fill="#FFDA3E"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17 10.7663L0 29.4663H34L17 10.7663Z"
                    fill="#FFCC00"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M34 4.53317L18.7721 19.3897C17.7797 20.3587 16.2204 20.3587 15.2279 19.3897L0 4.53317H34Z"
                    fill="#FF3333"
                  />
                </svg>
              </v-icon>
            </template>
            Yandex</v-btn
          >
        </v-col>
        <v-col class="ma-0 pa-0">
          <v-btn stacked variant="outlined" width="110" :disabled="loading">
            <template v-slot:prepend>
              <v-icon
                ><svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
                    fill="#005FF9"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 23.9603C10 16.2625 16.2802 10 23.9998 10C31.7194 10 37.9997 16.2625 37.9997 23.9603C37.9997 25.0508 37.9087 25.9336 37.7048 26.8197L37.7018 26.8344C37.7013 26.837 37.6001 27.2455 37.5442 27.4237C37.1982 28.5272 36.5718 29.4463 35.7325 30.0815C34.9186 30.6977 33.9094 31.0371 32.891 31.0371C32.7652 31.0371 32.6385 31.032 32.5144 31.0221C31.0682 30.9063 29.7966 30.1474 29.0168 28.9373C27.6757 30.282 25.8964 31.0218 23.9998 31.0218C20.0951 31.0218 16.9184 27.854 16.9184 23.9603C16.9184 20.0666 20.0951 16.8989 23.9998 16.8989C27.9045 16.8989 31.0812 20.0666 31.0812 23.9603V26.2366C31.087 27.5648 31.9808 28.1077 32.7444 28.1691C33.5041 28.2276 34.5152 27.7863 34.8674 26.3461C35.0411 25.5562 35.1294 24.7533 35.1294 23.9603C35.1294 17.8407 30.1367 12.8621 23.9998 12.8621C17.8629 12.8621 12.8703 17.8407 12.8703 23.9603C12.8703 30.0798 17.8629 35.0585 23.9998 35.0585C26.136 35.0585 28.2136 34.4501 30.0079 33.2991L30.0401 33.2784L31.9261 35.465L31.8856 35.4926C29.5549 37.0811 26.828 37.9207 23.9998 37.9207C16.2802 37.9207 10 31.6581 10 23.9603ZM23.9998 28.1596C26.3218 28.1596 28.2109 26.2758 28.2109 23.9603C28.2109 21.6448 26.3218 19.7612 23.9998 19.7612C21.6777 19.7612 19.7887 21.6448 19.7887 23.9603C19.7887 26.2758 21.6777 28.1596 23.9998 28.1596Z"
                    fill="#FF9E00"
                  />
                </svg>
              </v-icon>
            </template>
            Mail.ru</v-btn
          >
        </v-col>
        <v-col align="center" class="ma-0 pa-0 mt-5">
          <v-btn
            stacked
            variant="outlined"
            @click="isAuthForm = !isAuthForm"
            :disabled="loading"
          >
            <template v-slot:prepend>
              <v-icon
                ><svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.15385 2C4.52174 2 2.95649 2.64835 1.80242 3.80242C0.64835 4.95649 0 6.52174 0 8.15385V22.9231C0 24.5552 0.64835 26.1204 1.80242 27.2745C2.95649 28.4286 4.52174 29.0769 6.15385 29.0769H7.38462V20.4615C7.38462 18.8294 8.03297 17.2642 9.18704 16.1101C10.3411 14.956 11.9064 14.3077 13.5385 14.3077H27.0769V8.15385C27.0769 6.52174 26.4286 4.95649 25.2745 3.80242C24.1204 2.64835 22.5552 2 20.9231 2H6.15385ZM6.15385 8.15385C6.15385 7.82743 6.28352 7.51438 6.51433 7.28356C6.74514 7.05275 7.0582 6.92308 7.38462 6.92308H19.6923C20.0187 6.92308 20.3318 7.05275 20.5626 7.28356C20.7934 7.51438 20.9231 7.82743 20.9231 8.15385C20.9231 8.48027 20.7934 8.79332 20.5626 9.02413C20.3318 9.25495 20.0187 9.38462 19.6923 9.38462H7.38462C7.0582 9.38462 6.74514 9.25495 6.51433 9.02413C6.28352 8.79332 6.15385 8.48027 6.15385 8.15385ZM9.85108 20.2868C9.89599 19.339 10.3041 18.4448 10.9906 17.7899C11.6772 17.1349 12.5896 16.7694 13.5385 16.7692H28.3077C29.2566 16.7694 30.1689 17.1349 30.8555 17.7899C31.5421 18.4448 31.9502 19.339 31.9951 20.2868L20.9231 26.4382L9.85108 20.2868ZM21.5188 28.9218L32 23.1003V30.3077C32 31.287 31.611 32.2261 30.9186 32.9186C30.2261 33.611 29.287 34 28.3077 34H13.5385C12.5592 34 11.62 33.611 10.9276 32.9186C10.2352 32.2261 9.84615 31.287 9.84615 30.3077V23.1003L20.3249 28.9218C20.5079 29.0236 20.7137 29.077 20.9231 29.077C21.1324 29.077 21.3383 29.0236 21.5212 28.9218"
                    fill="url(#paint0_linear_468_2875)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_468_2875"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="34"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1E5AEF" />
                      <stop offset="1" stop-color="#1AD1FD" />
                    </linearGradient>
                  </defs>
                </svg>
              </v-icon>
            </template>
            Настроить вручную</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-dialog
          transition="dialog-right-transition"
          scrollable
          fullscreen
          persistent
          v-model="isAuthForm"
        >
          <v-sheet
            v-touch="{
              right: () => (isAuthForm = !isAuthForm),
            }"
          >
            <v-row class="align-center mt-2 mb-4">
              <v-col cols="2"
                ><v-btn
                  variant="text"
                  @click="isAuthForm = !isAuthForm"
                  icon="mdi-chevron-left"
                  :disabled="loading"
                ></v-btn
              ></v-col>
              <v-col>Настройка учетной записи</v-col>
            </v-row>
            <v-form class="pa-4">
              <v-text-field
                v-model="login"
                label="E-mail"
                type="email"
                clearable
                variant="outlined"
                :disabled="loading"
                rounded="lg"
              ></v-text-field>
              <v-text-field
                :append-inner-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPass ? 'text' : 'password'"
                @click:append-inner="showPass = !showPass"
                rounded="lg"
                variant="outlined"
                label="Пароль"
                :disabled="loading"
                v-model="pass"
              ></v-text-field>
              <v-select
                label="Сервер"
                :items="servers"
                v-model="selectServer"
                variant="outlined"
                rounded="lg"
                :disabled="loading"
              ></v-select>
              <template v-if="selectServer == 'Свой сервер(IMAP)'">
                <v-text-field
                  label="addres in"
                  v-model="addresIn"
                  clearable
                  variant="outlined"
                  rounded="lg"
                  :disabled="loading"
                ></v-text-field>
                <v-text-field
                  label="port in"
                  v-model="portIn"
                  clearable
                  variant="outlined"
                  rounded="lg"
                  :disabled="loading"
                ></v-text-field>
                <v-text-field
                  label="addres out"
                  v-model="addresOut"
                  clearable
                  variant="outlined"
                  rounded="lg"
                  :disabled="loading"
                ></v-text-field>
                <v-text-field
                  label="port out"
                  v-model="portOut"
                  clearable
                  variant="outlined"
                  rounded="lg"
                  :disabled="loading"
                ></v-text-field>
              </template>
              <v-btn
                block
                rounded="xl"
                variant="flat"
                height="50"
                color="#2CA6F7"
                :disabled="loading"
                @click="auth(login, pass, selectServer)"
                >Войти</v-btn
              >
            </v-form>
            <v-col> </v-col>
          </v-sheet>
        </v-dialog>
      </v-row>
    </v-container>
    <v-container v-else fluid class="ma-0 pa-0">
      <v-row class="ma-0 pa-0">
        <v-col cols="6" class="ma-0 pa-0">
          <v-img
            cover
            :height="height"
            :src="`https://spa-bitrix.ru/files/Rectangle%201882.png`"
          ></v-img>
        </v-col>
        <v-col cols="6" class="ma-0 pa-0">
          <v-container
            v-if="isAuthForm"
            height="100%"
            align="center"
            class="align-content-center ma-0 pa-0"
          >
            <v-row justify="center">
              <v-sheet
                v-touch="{
                  right: () => (isAuthForm = !isAuthForm),
                }"
              >
                <v-row class="align-center mt-2 mb-4">
                  <v-col cols="2"
                    ><v-btn
                      variant="text"
                      @click="isAuthForm = !isAuthForm"
                      icon="mdi-chevron-left"
                    ></v-btn
                  ></v-col>
                  <v-col>Настройка учетной записи</v-col>
                </v-row>
                <v-form class="pa-4">
                  <v-text-field
                    v-model="login"
                    label="E-mail"
                    type="email"
                    clearable
                    variant="outlined"
                    rounded="lg"
                    :disabled="loading"
                  ></v-text-field>
                  <v-text-field
                    :append-inner-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPass ? 'text' : 'password'"
                    @click:append-inner="showPass = !showPass"
                    rounded="lg"
                    variant="outlined"
                    label="Пароль"
                    :disabled="loading"
                    v-model="pass"
                  ></v-text-field>
                  <v-select
                    label="Сервер"
                    :items="servers"
                    v-model="selectServer"
                    variant="outlined"
                    rounded="lg"
                    :disabled="loading"
                  ></v-select>
                  <template v-if="selectServer == 'Свой сервер(IMAP)'">
                    <v-text-field
                      label="addres in"
                      v-model="addresIn"
                      clearable
                      variant="outlined"
                      rounded="lg"
                      :disabled="loading"
                    ></v-text-field>
                    <v-text-field
                      label="port in"
                      v-model="portIn"
                      clearable
                      variant="outlined"
                      rounded="lg"
                      :disabled="loading"
                    ></v-text-field>
                    <v-text-field
                      label="addres out"
                      v-model="addresOut"
                      clearable
                      variant="outlined"
                      rounded="lg"
                      :disabled="loading"
                    ></v-text-field>
                    <v-text-field
                      label="port out"
                      v-model="portOut"
                      clearable
                      variant="outlined"
                      rounded="lg"
                      :disabled="loading"
                    ></v-text-field>
                  </template>
                  <v-btn
                    block
                    rounded="lg"
                    variant="flat"
                    height="50"
                    color="#2CA6F7"
                    @click="auth(login, pass, selectServer)"
                    :disabled="loading"
                    >Войти</v-btn
                  >
                </v-form>
                <v-col> </v-col>
              </v-sheet>
            </v-row>
          </v-container>
          <v-container
            v-else
            height="100%"
            align="center"
            class="align-content-center ma-0 pa-0"
          >
            <v-row>
              <v-col align="center">
                <h1>Настройка электронной почты</h1>
              </v-col>
            </v-row>
            <v-row class="mb-4" style="justify-self: center">
              <v-col class="ma-0 pa-0 mr-4">
                <v-btn
                  stacked
                  variant="outlined"
                  width="150"
                  :disabled="loading"
                >
                  <template v-slot:prepend>
                    <v-icon class="mr-2"
                      ><svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M31.96 17.3542C31.96 16.2492 31.8608 15.1867 31.6767 14.1667H17V20.2017H25.3867C25.0183 22.1425 23.9133 23.7858 22.2558 24.8908V28.815H27.3133C30.26 26.095 31.96 22.1 31.96 17.3542Z"
                          fill="#4285F4"
                        />
                        <path
                          d="M17 32.5833C21.2075 32.5833 24.735 31.195 27.3133 28.815L22.2558 24.8908C20.8675 25.8258 19.0967 26.3925 17 26.3925C12.9483 26.3925 9.50583 23.6583 8.27333 19.975H3.08833V23.9983C5.6525 29.0842 10.9083 32.5833 17 32.5833Z"
                          fill="#34A853"
                        />
                        <path
                          d="M8.27333 19.9608C7.96166 19.0258 7.7775 18.0342 7.7775 17C7.7775 15.9658 7.96166 14.9742 8.27333 14.0392V10.0158H3.08833C2.02583 12.1125 1.41666 14.4783 1.41666 17C1.41666 19.5217 2.02583 21.8875 3.08833 23.9842L7.12583 20.8392L8.27333 19.9608Z"
                          fill="#FBBC05"
                        />
                        <path
                          d="M17 7.62166C19.295 7.62166 21.335 8.41499 22.9642 9.94499L27.4267 5.48249C24.7208 2.96082 21.2075 1.41666 17 1.41666C10.9083 1.41666 5.6525 4.91582 3.08833 10.0158L8.27333 14.0392C9.50583 10.3558 12.9483 7.62166 17 7.62166Z"
                          fill="#EA4335"
                        />
                      </svg>
                    </v-icon>
                    Gmail
                  </template>
                </v-btn>
              </v-col>
              <v-col class="ma-0 pa-0">
                <v-btn
                  stacked
                  variant="outlined"
                  width="150"
                  :disabled="loading"
                >
                  <template v-slot:prepend>
                    <v-icon class="mr-2"
                      ><svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 29.4666H34V4.53317H0V29.4666Z"
                          fill="#FFDA3E"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M17 10.7663L0 29.4663H34L17 10.7663Z"
                          fill="#FFCC00"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M34 4.53317L18.7721 19.3897C17.7797 20.3587 16.2204 20.3587 15.2279 19.3897L0 4.53317H34Z"
                          fill="#FF3333"
                        />
                      </svg>
                    </v-icon>
                    Yandex
                  </template>
                </v-btn>
              </v-col>
            </v-row>
            <v-row style="justify-self: center">
              <v-col class="ma-0 pa-0 mr-4">
                <v-btn
                  stacked
                  variant="outlined"
                  width="150"
                  :disabled="loading"
                >
                  <template v-slot:prepend>
                    <v-icon class="mr-2"
                      ><svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
                          fill="#005FF9"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10 23.9603C10 16.2625 16.2802 10 23.9998 10C31.7194 10 37.9997 16.2625 37.9997 23.9603C37.9997 25.0508 37.9087 25.9336 37.7048 26.8197L37.7018 26.8344C37.7013 26.837 37.6001 27.2455 37.5442 27.4237C37.1982 28.5272 36.5718 29.4463 35.7325 30.0815C34.9186 30.6977 33.9094 31.0371 32.891 31.0371C32.7652 31.0371 32.6385 31.032 32.5144 31.0221C31.0682 30.9063 29.7966 30.1474 29.0168 28.9373C27.6757 30.282 25.8964 31.0218 23.9998 31.0218C20.0951 31.0218 16.9184 27.854 16.9184 23.9603C16.9184 20.0666 20.0951 16.8989 23.9998 16.8989C27.9045 16.8989 31.0812 20.0666 31.0812 23.9603V26.2366C31.087 27.5648 31.9808 28.1077 32.7444 28.1691C33.5041 28.2276 34.5152 27.7863 34.8674 26.3461C35.0411 25.5562 35.1294 24.7533 35.1294 23.9603C35.1294 17.8407 30.1367 12.8621 23.9998 12.8621C17.8629 12.8621 12.8703 17.8407 12.8703 23.9603C12.8703 30.0798 17.8629 35.0585 23.9998 35.0585C26.136 35.0585 28.2136 34.4501 30.0079 33.2991L30.0401 33.2784L31.9261 35.465L31.8856 35.4926C29.5549 37.0811 26.828 37.9207 23.9998 37.9207C16.2802 37.9207 10 31.6581 10 23.9603ZM23.9998 28.1596C26.3218 28.1596 28.2109 26.2758 28.2109 23.9603C28.2109 21.6448 26.3218 19.7612 23.9998 19.7612C21.6777 19.7612 19.7887 21.6448 19.7887 23.9603C19.7887 26.2758 21.6777 28.1596 23.9998 28.1596Z"
                          fill="#FF9E00"
                        />
                      </svg>
                    </v-icon>
                    Mail.ru
                  </template>
                </v-btn>
              </v-col>
              <v-col align="center" class="ma-0 pa-0">
                <v-btn
                  stacked
                  variant="outlined"
                  @click="isAuthForm = !isAuthForm"
                  :disabled="loading"
                >
                  <template v-slot:prepend>
                    <v-icon
                      ><svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.15385 2C4.52174 2 2.95649 2.64835 1.80242 3.80242C0.64835 4.95649 0 6.52174 0 8.15385V22.9231C0 24.5552 0.64835 26.1204 1.80242 27.2745C2.95649 28.4286 4.52174 29.0769 6.15385 29.0769H7.38462V20.4615C7.38462 18.8294 8.03297 17.2642 9.18704 16.1101C10.3411 14.956 11.9064 14.3077 13.5385 14.3077H27.0769V8.15385C27.0769 6.52174 26.4286 4.95649 25.2745 3.80242C24.1204 2.64835 22.5552 2 20.9231 2H6.15385ZM6.15385 8.15385C6.15385 7.82743 6.28352 7.51438 6.51433 7.28356C6.74514 7.05275 7.0582 6.92308 7.38462 6.92308H19.6923C20.0187 6.92308 20.3318 7.05275 20.5626 7.28356C20.7934 7.51438 20.9231 7.82743 20.9231 8.15385C20.9231 8.48027 20.7934 8.79332 20.5626 9.02413C20.3318 9.25495 20.0187 9.38462 19.6923 9.38462H7.38462C7.0582 9.38462 6.74514 9.25495 6.51433 9.02413C6.28352 8.79332 6.15385 8.48027 6.15385 8.15385ZM9.85108 20.2868C9.89599 19.339 10.3041 18.4448 10.9906 17.7899C11.6772 17.1349 12.5896 16.7694 13.5385 16.7692H28.3077C29.2566 16.7694 30.1689 17.1349 30.8555 17.7899C31.5421 18.4448 31.9502 19.339 31.9951 20.2868L20.9231 26.4382L9.85108 20.2868ZM21.5188 28.9218L32 23.1003V30.3077C32 31.287 31.611 32.2261 30.9186 32.9186C30.2261 33.611 29.287 34 28.3077 34H13.5385C12.5592 34 11.62 33.611 10.9276 32.9186C10.2352 32.2261 9.84615 31.287 9.84615 30.3077V23.1003L20.3249 28.9218C20.5079 29.0236 20.7137 29.077 20.9231 29.077C21.1324 29.077 21.3383 29.0236 21.5212 28.9218"
                          fill="url(#paint0_linear_468_2875)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_468_2875"
                            x1="16"
                            y1="2"
                            x2="16"
                            y2="34"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#1E5AEF" />
                            <stop offset="1" stop-color="#1AD1FD" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </v-icon>
                    Настроить <br />
                    вручную
                  </template>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Auth-component",
  data() {
    return {
      clientId: "70d9b835c8234f26a1ea4291c31ed636",
      redirectUri: "http://localhost:8080/", // Укажите ваш Callback URL
      width: 0,
      height: 0,
      showPass: false,
      isTrue: false,
      disabled: true,
      isAuthForm: false,
      login: "",
      pass: "",
      selectServer: "",
      portIn: "",
      portOut: "",
      addresIn: "",
      addresOut: "",
      servers: [
        "Yandex",
        "Mail",
        "Gmail",
        "Rambler",
        "Yahoo",
        "Свой сервер(IMAP)",
      ],
      interval: -1,
      value: 0,
      loading: false,
    };
  },
  methods: {
    loginWithYandex() {
      const authUrl = `https://oauth.yandex.ru/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUri}`;
      console.log({ authUrl });
      window.location.href = authUrl; // Перенаправление на страницу авторизации Яндекса
    },
    async exchangeCodeForToken(code) {
      const tokenUrl = "https://oauth.yandex.ru/token";
      const params = new URLSearchParams();
      params.append("grant_type", "authorization_code");
      params.append("code", code);
      params.append("client_id", this.clientId);
      params.append("client_secret", "ВАШ_CLIENT_SECRET");

      try {
        const response = await axios.post(tokenUrl, params);
        const accessToken = response.data.access_token;
        this.fetchUserInfo(accessToken); // Получение информации о пользователе
      } catch (error) {
        console.error("Ошибка при получении токена:", error);
      }
    },
    async fetchUserInfo(accessToken) {
      const userInfoUrl = "https://login.yandex.ru/info?format=json";
      try {
        const response = await axios.get(userInfoUrl, {
          headers: { Authorization: `OAuth ${accessToken}` },
        });
        console.log("Информация о пользователе:", response.data);
        // Здесь можно сохранить данные пользователя в хранилище (например, Vuex)
      } catch (error) {
        console.error("Ошибка при получении информации о пользователе:", error);
      }
    },
    groupMessagesByDate(messages) {
      const today = new Date(); // Текущая дата
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1); // Вчера
      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7); // Неделя назад
      const lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1); // Месяц назад

      const groupedMessages = {
        today: {
          title: "Сегодня",
          mails: [],
        },
        yesterday: {
          title: "Вчера",
          mails: [],
        },
        lastWeek: {
          title: "За последную неделю",
          mails: [],
        },
        lastMonth: {
          title: "За последний месяц",
          mails: [],
        },
        older: {
          title: "Больше месяца",
          mails: [],
        },
      };

      messages.forEach((message) => {
        console.log(message.date, "date");
        const messageDate = new Date(message.date);

        if (messageDate.toDateString() === today.toDateString()) {
          groupedMessages.today.mails.push(message); // Сегодня
        } else if (messageDate.toDateString() === yesterday.toDateString()) {
          groupedMessages.yesterday.mails.push(message); // Вчера
        } else if (messageDate > lastWeek) {
          groupedMessages.lastWeek.mails.push(message); // За последнюю неделю
        } else if (messageDate > lastMonth) {
          groupedMessages.lastMonth.mails.push(message); // За последний месяц
        } else {
          groupedMessages.older.mails.push(message); // Старое
        }
      });

      return groupedMessages;
    },
    //TODO сделать авторизацию через апи яндекса/маил остальное руками ввод
    async auth(login, pass, selectServer, type = "new") {
      this.loading = true;
      //ч
      // ggeflhzyblvbqlic
      console.log(login);
      let formData = new FormData();
      formData.append(`params`, "checkConnectImap");
      formData.append(`login`, login);
      formData.append(`password`, pass);
      formData.append(
        `host`,
        this.$store.state.settings[selectServer].imap.address
      );
      formData.append(
        `port`,
        this.$store.state.settings[selectServer].imap.port
      );
      formData.append(`encrypt`, "ssl");
      formData.append(`type`, pass ? "password" : "oauth");

      const isAuth = await axios.post("https://email.rcgit.ru/imap/", formData);
      console.log(isAuth);

      if (isAuth.data == 1) {
        if (type == "new") {
          const mailbox = {
            title: login,
            icon: "",
            pass: pass,
            server: selectServer,
            encrypt: "ssl",
            type: pass ? "password" : "oauth",
            folders: [],
          };
          // this.$store.commit("mailboxSettingAdd", mailbox);

          this.$store.commit("mailboxAdd", mailbox);
          const formDataString = JSON.stringify(this.$store.state.mailbox);
          // Сохраняем строку в localStorage
          localStorage.setItem("imapSettings", formDataString);
        }
        this.$store.commit("setAuth", true);
      } else {
        alert("Не верный логин или пароль!");
      }
      this.loading = false;
    },
    isDisabled() {
      console.log("is disabled");
      if (
        this.login.length > 0 &&
        this.pass.length > 0 &&
        this.selectServer.length > 0
      ) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },
  async created() {
    this.height = window.innerHeight;
    // Проверка, есть ли код в URL после перенаправления
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      this.exchangeCodeForToken(code); // Обмен кода на токен
    }
    if (localStorage.getItem("imapSettings") && !this.$store.state.isNewBox) {
      this.loading = true;
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0);
        }
        this.value += 10;
      }, 1000);
      const mailboxSetting = JSON.parse(localStorage.getItem("imapSettings"));
      this.$store.commit("mailboxSettingStart", mailboxSetting);
      this.$store.commit("mailboxAddStart", mailboxSetting);
      console.log(this.$store.state.mailbox, "mailbox");

      await this.auth(
        this.$store.state.mailboxSetting[0].title,
        this.$store.state.mailboxSetting[0].pass,
        this.$store.state.mailboxSetting[0].server,
        "old"
      );

      this.loading = false;
    }
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
};
</script>
